/* The filters, easier to find (Seth 2026-10-11): the one-time nudge on the Filter button, the phone's sticky Filter and
   sort, and the phone's Clarity event.
   The nudge plays once per visit, on the first collection page where the button is fully on screen, only before any
   filter is in use, and never for visitors who ask their device for less motion. It lasts under two seconds
   (assets/mad-filter-button.css). The visit is remembered in sessionStorage only for this (no sizes, no person).
   Phones, second check of 2026-10-11:
   - only the button stays on screen: the chips of the filters in use move to just under the sticky bar, so a filter in
     use no longer makes the bar 134px tall (the theme redraws them by class, wherever they are);
   - closing the drawer leaves the page where it was: the theme hands focus back to the button, and a stuck button sat
     inside html's scroll-padding band, so the browser scrolled about 300px to "show" it;
   - after a filter change made in the drawer, the first doors of the new list start just under the bar.
   Clarity events: filters_nudge (the nudge played), filters_open_phone (the phone's Filter and sort opened); the
   computer openers are counted in assets/mad-filter-drawer.js. Since the heatmap check of 2026-10-11 also pager_next,
   pager_prev and pager_jump (the page links under the doors), and a 450 ms guard against a quick second tap. */
(function () {
  'use strict';
  if (window.__madFilterButton) return;
  window.__madFilterButton = true;
  var KEY = 'mad-fnudge';

  /* snippets/mad-clarity.liquid holds markers until Clarity has started (window.madClarityEvent) */
  function tag(name) { try { if (typeof window.madClarityEvent === 'function') window.madClarityEvent(name); else if (typeof window.clarity === 'function') window.clarity('event', name); } catch (e) { /* never block */ } }

  /* Heatmap check of 2026-10-11: the open drawer puts its own header (the X) where a stuck button was, and on the first
     screen its footer (Show N, Clear) under the finger, so a quick second tap closed the drawer just opened. For 450 ms
     after it opens, taps on the toggle (the X sits inside it) and the footer's buttons do nothing; the heading's taps were
     already harmless. */
  var openedAt = 0;
  document.addEventListener('click', function (e) {
    var t = e.target;
    if (!t || !t.closest) return;
    var s = t.closest('.mad-fbar .mobile-facets__open-wrapper'), d = s && s.closest('details');
    if (d && !d.hasAttribute('open')) { openedAt = Date.now(); tag('filters_open_phone'); return; }
    if (openedAt && Date.now() - openedAt < 450 && (s || t.closest('.mad-fbar .mobile-facets__close, .mad-fbar .mobile-facets__footer a, .mad-fbar .mobile-facets__footer button'))) {
      e.preventDefault(); e.stopImmediatePropagation();
    }
  }, true);

  /* Heatmap check of 2026-10-11: Clarity draws the pager's digits as squares, so its labels cannot say which page link was
     used. These markers do: pager_next (the next page), pager_prev (any earlier page), pager_jump (a later page past the
     next). The pager keeps its plain links (search engines follow them). */
  document.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('.pagination a[href]');
    if (!a) return;
    var wrap = a.closest('[data-page]'), here = wrap ? parseInt(wrap.getAttribute('data-page'), 10) : NaN;
    var m = /[?&]page=(\d+)/.exec(a.getAttribute('href') || ''), to = m ? parseInt(m[1], 10) : 1;
    if (!(here > 0)) return;
    tag(to === here + 1 ? 'pager_next' : to < here ? 'pager_prev' : 'pager_jump');
  }, true);

  function phoneBar() {
    var bar = document.querySelector('.mad-fbar--sticky');
    if (!bar) return;
    var pills = bar.querySelector('.active-facets-mobile');
    if (pills && bar.parentNode) {
      pills.classList.add('mad-fbar-pills');
      bar.parentNode.insertBefore(pills, bar.nextSibling);
    }
    var summary = bar.querySelector('.mobile-facets__open-wrapper');
    if (summary && !summary.hasAttribute('data-mad-fbar-focus')) {
      summary.setAttribute('data-mad-fbar-focus', '');
      var focus = summary.focus;
      summary.focus = function (opts) {
        var o = { preventScroll: true };
        if (opts && typeof opts === 'object') for (var k in opts) if (k !== 'preventScroll') o[k] = opts[k];
        try { focus.call(summary, o); } catch (err) { focus.call(summary); }
      };
    }
    var details = bar.querySelector('.mobile-facets__disclosure');
    var grid = document.getElementById('ProductGridContainer');
    if (!details || !grid || !window.MutationObserver) return;
    /* A change made in the drawer (a tick, a sort, Remove all) is pending until the new doors arrive. The theme asks for
       them 800ms after the change and the drawer closes 400ms after Show, so a quick Show closes the drawer first
       (final check of 2026-10-11): the results are lined up when the drawer closes if they are already there, or as
       soon as they arrive after it closed. A touch on the page, or 6 seconds, drops a wait. */
    var pending = false, arrived = false, waiting = 0;
    function mark() { if (details.hasAttribute('open')) { pending = true; arrived = false; } }
    function drop() { pending = false; arrived = false; if (waiting) { window.clearTimeout(waiting); waiting = 0; } }
    function lineUp() {
      drop();
      window.requestAnimationFrame(function () {
        var top = grid.getBoundingClientRect().top, under = bar.getBoundingClientRect().bottom;
        if (top >= under) return;
        var y = window.scrollY + top - bar.offsetHeight - 8;
        /* scrolling up brings the header back above the bar */
        if (y < window.scrollY) y -= parseFloat(window.getComputedStyle(document.documentElement).getPropertyValue('--header-height')) || 0;
        window.scrollTo(0, Math.max(0, Math.round(y)));
      });
    }
    var form = document.getElementById('FacetFiltersFormMobile');
    if (form) { form.addEventListener('input', mark); form.addEventListener('change', mark); }
    details.addEventListener('click', function (e) { if (e.target.closest && e.target.closest('facet-remove')) mark(); }, true);
    new MutationObserver(function () {
      if (!pending) return;
      arrived = true;
      if (waiting) lineUp();
    }).observe(grid, { childList: true });
    new MutationObserver(function () {
      if (details.hasAttribute('open') || !pending) return;
      if (arrived) { lineUp(); return; }
      waiting = window.setTimeout(drop, 6000);
      window.addEventListener('touchstart', function () { if (waiting) drop(); }, { once: true, passive: true });
    }).observe(details, { attributes: true, attributeFilter: ['open'] });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', phoneBar); else phoneBar();

  if (!document.querySelector('[data-mad-fnudge]')) return;
  if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  if (/[?&]filter\./.test(window.location.search)) return;
  try { if (window.sessionStorage.getItem(KEY)) return; } catch (e) { return; }
  if (!('IntersectionObserver' in window)) return;

  function target() {
    var list = document.querySelectorAll('.mad-fbtn, .mad-fbar .mobile-facets__open');
    for (var i = 0; i < list.length; i++) if (list[i].offsetParent !== null) return list[i];
    return null;
  }
  function play(el) {
    try { window.sessionStorage.setItem(KEY, '1'); } catch (e) { /* the nudge may then play again; harmless */ }
    el.classList.add('mad-fnudge');
    window.setTimeout(function () { el.classList.remove('mad-fnudge'); }, 1700);
    tag('filters_nudge');
  }
  function arm() {
    var el = target();
    if (!el) return;
    var done = false;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (done || !en.isIntersecting || en.intersectionRatio < 0.99) return;
        done = true;
        io.disconnect();
        window.setTimeout(function () { play(el); }, 400);
      });
    }, { threshold: [0.99] });
    io.observe(el);
  }
  if (document.readyState === 'complete') window.setTimeout(arm, 600);
  else window.addEventListener('load', function () { window.setTimeout(arm, 600); });
})();
